/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{resolveIncludes as e}from"./sources/resolver.js";const r={shaders:{vertexShader:e("stencil/stencil.vert"),fragmentShader:e("stencil/stencil.frag")},attributes:new Map([["a_pos",0]])};export{r as stencil};
